import React, { useState, useEffect } from 'react';
import { BackupManager } from '../components/BackupManager';
import PrivateRoute from '../components/PrivateRoute';
import { authService } from '../services/authService';

/**
 * Backups Page
 * 
 * Page for managing database backups with full functionality.
 * Requires admin permissions to access.
 */

const BackupsPageContent: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <main className="flex-1 p-4 md:p-6">
        <BackupManager />
      </main>
    </div>
  );
};

/**
 * Backups Page with Private Route
 * 
 * Wrapped in PrivateRoute to ensure only authenticated users can access.
 * Requires Administrator role.
 */
const BackupsPage: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const authenticated = await authService.initializeAuth();
        setIsAuthenticated(authenticated);
      } catch {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkAuth();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <PrivateRoute requiredRole="Administrator" isAuthenticated={isAuthenticated}>
      <BackupsPageContent />
    </PrivateRoute>
  );
};

export default BackupsPage;
